import { render, staticRenderFns } from "./station-cocal-message-list.vue?vue&type=template&id=0c5bc5b3&"
import script from "./station-cocal-message-list.vue?vue&type=script&lang=js&"
export * from "./station-cocal-message-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports